import script from "./orders.vue?vue&type=script&setup=true&lang=js"
export * from "./orders.vue?vue&type=script&setup=true&lang=js"

import "./orders.vue?vue&type=style&index=0&id=58eae90c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58eae90c"]])

export default __exports__